import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BulkRiskUploadComponent } from '../bulk-risk-upload/bulk-risk-upload.component';

@Component({
  selector: 'app-components',
  standalone: true,
  imports: [CommonModule, BulkRiskUploadComponent],
  template: ` <app-bulk-risk-upload></app-bulk-risk-upload> `,
  styles: []
})
export class ComponentsComponent {}
